/* Vanderism storefront interaction tracking, v1. Upload as assets/vanderism-cta-tracking.js, then load once before </body> in layout/theme.liquid. */
(function () {
  'use strict';
  if (window.__vdrCtaTracking) return;
  window.__vdrCtaTracking = true;

  var SELECTOR = 'a[href],button,[role="button"],input[type="submit"],input[type="button"]';
  var observed = new WeakSet();
  var visible = new WeakSet();
  var observer;

  function trim(value, max) {
    return String(value || '').replace(/\s+/g, ' ').trim().slice(0, max);
  }
  function eligible(el) {
    if (!el || el.disabled || el.getAttribute('aria-disabled') === 'true') return false;
    if (el.closest('[inert]')) return false;
    return !!el.getClientRects().length && getComputedStyle(el).visibility !== 'hidden';
  }
  function destination(el) {
    var raw = el.getAttribute('href');
    if (!raw) return { domain: '', path: '' };
    try {
      var u = new URL(raw, location.href);
      if (!/^https?:$/.test(u.protocol)) return { domain: '', path: '' };
      // Strip all query parameters and fragments: WA links may contain phone numbers/message text.
      return { domain: u.hostname, path: u.hostname === location.hostname ? u.pathname : '' };
    } catch (_) { return { domain: '', path: '' }; }
  }
  function details(el) {
    var target = destination(el);
    var label = trim(el.getAttribute('data-analytics-id') || el.getAttribute('aria-label') ||
      el.innerText || el.getAttribute('value') || el.querySelector('img[alt]')?.getAttribute('alt') || '', 80);
    // Never send customer contact details as event parameters.
    label = label.replace(/[\w.+-]+@[\w.-]+\.[A-Za-z]{2,}/g, '[email]')
      .replace(/(?:\+?\d[\d\s().-]{7,}\d)/g, '[phone]');
    var context = el.closest('main,header,footer,aside');
    var section = context ? context.tagName.toLowerCase() : 'other';
    var marker = (label + ' ' + target.domain + ' ' +
      (el.getAttribute('data-m9-buy') !== null ? 'checkout' : '')).toLowerCase();
    var type = /wa\.me|whatsapp|tanya produk|konsultasi/.test(marker) ? 'whatsapp' :
      /checkout|bayar|beli sekarang/.test(marker) ? 'checkout' :
      /keranjang|add to cart|tambahkan ke cart/.test(marker) ? 'cart' :
      el.tagName === 'A' ? 'link' : 'button';
    return {
      cta_label: label || 'unlabeled',
      cta_type: type,
      cta_section: section,
      cta_destination_domain: target.domain,
      cta_destination_path: target.path,
      cta_page_path: location.pathname
    };
  }
  function send(name, el) {
    if (typeof window.gtag !== 'function') return false;
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (privacy && typeof privacy.analyticsProcessingAllowed === 'function' &&
        !privacy.analyticsProcessingAllowed()) return false;
    window.gtag('event', name, Object.assign({send_to: 'G-5EE4MQRLE9'}, details(el)));
    return true;
  }
  document.addEventListener('click', function (event) {
    var el = event.target instanceof Element ? event.target.closest(SELECTOR) : null;
    if (el && eligible(el)) send('vdr_cta_click', el);
  }, true);

  if ('IntersectionObserver' in window) {
    var impressionNumber = 0;
    var pendingViews = [];
    function flushViews() {
      if (!performance.getEntriesByType('resource').some(function (item) {
        return item.name.indexOf('google-analytics.com/g/collect') !== -1;
      })) return;
      if (!pendingViews.length) return;
      var batch = pendingViews.splice(0);
      batch.forEach(function (el, i) {
        setTimeout(function () { if (el.isConnected) send('vdr_cta_view', el); }, 2500 + i * 900);
      });
    }
    var viewTimer = setInterval(function () {
      flushViews();
      if (++impressionNumber > 40) clearInterval(viewTimer);
    }, 500);
    observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting || visible.has(entry.target) || !eligible(entry.target)) return;
        visible.add(entry.target);
        observer.unobserve(entry.target);
        pendingViews.push(entry.target);
        flushViews();
      });
    }, { threshold: 0.5 });
    function observe() {
      document.querySelectorAll(SELECTOR).forEach(function (el) {
        if (!observed.has(el) && !el.closest('[hidden],[inert]')) {
          observed.add(el);
          observer.observe(el);
        }
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', observe, { once: true });
    else observe();
    var pending = false;
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () { pending = false; observe(); });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
